/* eslint-disable react/no-unescaped-entities */
// eslint-disable-next-line no-unused-vars
import React from "react";
import { Box, Typography } from "@mui/material";

const PageNotFound = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: 'rgba(13, 18, 41, 1)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{

      }}>
        <img src='/404.gif' alt='404page' style={{
          width: '100%',
          maxWidth: "500px",
        }} />
      </Box>
    </Box>
  );
};

export default PageNotFound;
